export default "__VITE_ASSET__egotXMo9__"